import { inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AnalyticsService } from './analytics.service';

/** Subscribes to router navigations and emits PostHog page-view events. */
export function trackRouterEvents(): () => void {
  return () => {
    const analytics = inject(AnalyticsService);
    const router = inject(Router);

    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (!(event instanceof NavigationEnd)) {
          return;
        }

        analytics.capture('$pageview', {
          path: event.urlAfterRedirects,
        });
      });
  };
}
